function OpeningHoursModel(BaseModel) {
    'ngInject';

    class OpeningHours extends BaseModel {

        constructor(data) {
            super(data);
        }

        getDay(day) {
            return _.findWhere(this.openingHoursSpecification, {dayOfWeek: 'http://schema.org/' + day});
        }

        openTimes() {
            return _.map(this.openingHoursSpecification, day => day.opens);
        }

        earliestOpening() {
            return _.first(this.openTimes().sort());
        }

        closeTimes() {
            return _.map(this.openingHoursSpecification, day => day.closes);
        }

        latestClosing() {
            return _.last(this.closeTimes().sort());
        }

    }

    return OpeningHours;
}

/***
 * @ngdoc service
 * @name BB.Models:OpeningHours
 *
 * @description
 * Representation of a OpeningHours Object
 */
angular
    .module('BB')
    .service('OpeningHoursModel', OpeningHoursModel);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_models/opening_hours_model.service.js